import React from 'react'
import AboutUs from '../about-us'

const AboutUsPt = () => {
    return <AboutUs languageCode="pt" />
}

export default AboutUsPt
